export default __webpack_public_path__ + "static/media/logo-small.3ffe5f92.svg";